import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, memo, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface ServiceTableCollapseProps {
  onSubItemClick?: () => void;
  link: string;
  active: {
    ricercaRegistro: boolean;
    ricercaTipoPratica: boolean;
    ricercaTipoOperazione: boolean;
    ricercaResponsabile: boolean;
    ricercaMetrica: boolean;
  };
}

const ServiceTableCollapseComponent = ({
  onSubItemClick,
  link,
  active,
}: ServiceTableCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  return (
    <Fragment>
      <ListItem
        button
        key="Tabelle di servizio"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText className={classes.colorItems} primary="Tabelle di servizio" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {active.ricercaTipoPratica ? (
            <Link
              key={`${link}/ricerca-tipo-pratica`}
              to={`${link}/ricerca-tipo-pratica`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gestione Tipo Pratica" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.ricercaTipoOperazione ? (
            <Link
              key={`${link}/ricerca-tipo-operazione`}
              to={`${link}/ricerca-tipo-operazione`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gestione TIpo Operazione" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.ricercaRegistro ? (
            <Link
              key={`${link}/ricerca-registro`}
              to={`${link}/ricerca-registro`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gestione Registro" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.ricercaResponsabile ? (
            <Link
              key={`${link}/ricerca-responsabile`}
              to={`${link}/ricerca-responsabile`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gestione Responsabile" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.ricercaMetrica ? (
            <Link
              key={`${link}/ricerca-metrica`}
              to={`${link}/ricerca-metrica`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gestione Metriche" />
              </ListItem>
            </Link>
          ) : undefined}
        </List>
      </Collapse>
    </Fragment>
  );
};

ServiceTableCollapseComponent.displayName = 'Servive Table Collapse Item';

const ServiceTableCollapse = memo(ServiceTableCollapseComponent);

export default ServiceTableCollapse;
